import { CtrlType, Ctrl } from "@yuigoto/ctrl";

export const CouponControl = [
    {
        name: "couponName",
        required: true,
        requiredMessage: "Preencher o cupom é obrigatório",
        label: "Só poderá ser editado uma única vez",
        description: "utilize apenas letras e números, sem acentos, espaços ou caracteres especiais"
    },
  
]